module.exports = __webpack_public_path__ + "img/avatar-16.1b0906de.jpg";